module.exports = __webpack_public_path__ + "static/media/coertcoomans.805e5b1d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/coertcoomans.webp
// module id = 507
// module chunks = 0